export const DATADOME_ENDPOINT = 'https://account-api.datadome.co';
export const DATADOME_TIMEOUT = 1500;
export const SDK_VERSION = '2.1.1';
export const SDK_NAME = 'Fraud SDK Node.js';
